import { GetItemCounts, useInfiniteTags } from '@ukpostbox/client-data';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	ContentBlock,
	ContentLoader,
	SelectItemType,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { ShapeTagSelectData } from './TagHelpers';
import { AddTagControlMinimalFeType } from './Types/AddTagTypes';

function AddTagControlMinimal(props: AddTagControlMinimalFeType) {
	const { t } = useTranslation();
	const [tagData, setTagData] = useState<Array<SelectItemType>>([]);
	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const {
		status,
		data,
		error,
		hasNextPage,
		isStale,
		isRefetching,
		fetchNextPage,
		isFetchingNextPage,
		dataUpdatedAt,
	} = useInfiniteTags();

	const HandleChange = (e: Array<any>) => {
		if (props.updateCallback) {
			props.updateCallback(e);
		}
	};

	const HandleReset = () => {
		if (props.resetSelectedCallback) {
			props.resetSelectedCallback();
		}
	};

	useEffect(() => {
		if (data) {
			setItemCounts(GetItemCounts(data as any));
			setTagData(ShapeTagSelectData(data));
		}
	}, [dataUpdatedAt]);

	return status === 'pending' ? (
		<ContentLoader round childCount={1} />
	) : status === 'error' ? (
		<ContentBlock error stacked title={error.name} content={error.message} />
	) : (
		<ComboBoxControl
			name={props.name || 'addTagsMenu'}
			placeholder={props.placeholder || t('controls.tagsPlaceholder')}
			data={tagData}
			forwardValueCallback={(e) => (props.singleSelection ? HandleChange(e) : null)}
			forwardValuesCallback={(e) => HandleChange(e)}
			forwardItemCallback={(e) => {
				HandleChange([e.value]);
				if (props.onChangeItemsCallback) {
					props.onChangeItemsCallback(e);
				}
			}}
			resetSelectedCallback={() => HandleReset()}
			defaultValue={props.existingTags as Array<number>}
			loading={isFetchingNextPage}
			listAlwaysVisible={props.listAlwaysVisible}
			valueType='number'
			displayType={ComboBoxTypeEnum.Multi}
			displayItemLabelType={ComboBoxItemDisplayEnum.Label}
			formReset={props.reset}
			pagination={{
				hasNextPage,
				itemCounts,
				isStale,
				isRefetching,
				isFetchingNextPage,
				fetchNextPage,
			}}
		/>
	);
}

export default AddTagControlMinimal;
